<template>
  <div>
    <Header></Header>
    <div class="content">
      <div class="container">
        <div class="ui vertically divided grid">
          <div class="one column row text-right">
            <div class="column">
              <select v-if="getFullMessages > 0" class="msgSort ui dropdown">
                <option value>Sort By</option>
                <option value="1">Sent On</option>
                <option value="0">URL</option>
              </select>
            </div>
          </div>
        </div>
        <div
          v-bind:key="key"
          v-for="(message, key) in getFullMessages"
          :class="{ width60: !message.opened }"
          class="msgContainer"
        >
          <form class="ui form" @submit.prevent>
            <div
              v-if="!message.opened"
              :class="{ msgCloseMove: !message.opened }"
              class="msgClose"
            >
              <button
                @click="
                  message.privated = true;
                  message.public = true;
                  message.opened = true;
                  hideSort(message.queue_id);
                "
                class="ui icon button grey basic"
                type="button"
              >
                <i class="close large icon"></i>
              </button>
            </div>
            <div class="column">
              <div class="msgMeta">
                <b>ASKED ON:</b>
                {{ getDate(message.created_timestamp) }}
              </div>
              <div class="one column row">
                <div class="column msgText">
                  <div class="msgThumb">
                    <img alt="Page Thumbnail" src="../assets/screenPage.png" />
                  </div>

                  <i class="ui icon question circle outline large grey"></i>
                  <b>
                    {{ message.name }}
                    asked:
                  </b>

                  <p class="padding-l-40">{{ message.question }}</p>
                  <div
                    v-if="message.opened"
                    class="msgReplyOptions ui buttons"
                    id="btnAsk-Answer"
                  >
                    <button
                      @click="
                        message.opened = !message.opened;
                        onShowAskAnswer(message.queue_id);
                        getSuggestions(message, key);
                        categoriesSearched = [];
                        categoriesSelected = [];
                      "
                      class="msgAsk ui grey basic large button"
                      type="button"
                    >
                      <i class="icon question"></i>ASK
                    </button>
                    <button
                      @click="
                        message.opened = !message.opened;
                        onShowAskAnswer(message.queue_id);
                        getSuggestions(message, key);
                        categoriesSearched = [];
                        categoriesSelected = [];
                      "
                      class="msgAnswer ui blue large basic button"
                      type="button"
                    >
                      <i class="icon reply"></i>ANSWER
                    </button>
                  </div>
                </div>
                <div class="column">
                  <div v-if="!message.opened">
                    <span class="msgMeta">
                      <b>YOUR RESPONSE:</b>
                    </span>

                    <div class="msgReplyOptions">
                      <textarea
                        :id="'msgReply-' + key"
                        v-model="answer[key]"
                        class="msgReply"
                        placeholder="Enter your response here..."
                        style="display: inline-block;"
                      ></textarea>
                      <span class="msgMeta">
                        <b>SUGGESTIONS:</b>
                      </span>
                      <div
                        class="msgSuggestionContainer"
                        v-for="(suggestion, index) in suggestions"
                        :key="index"
                      >
                        <div
                          class="msgSuggestion"
                          @click="writeAnswer(key, suggestion.answer)"
                        >
                          <i class="ui lightbulb outline icon orange"></i>
                          {{ suggestion.answer }}
                        </div>
                      </div>
                    </div>
                    <div class="msgReplyOptions ui buttons">
                      <button
                        @click="
                          message.public = !message.public;
                          message.privated = true;
                        "
                        :class="{ primary: message.public === false }"
                        class="msgPublic ui grey basic large button"
                        type="button"
                      >
                        <i class="icon users"></i>PUBLIC
                      </button>
                      <button
                        @click="
                          message.privated = !message.privated;
                          message.public = true;
                        "
                        :class="{ primary: message.privated === false }"
                        class="msgPublic ui grey basic large button"
                        type="button"
                      >
                        <i class="icon user"></i>PRIVATE
                      </button>
                    </div>
                    <div v-if="!message.public">
                      <div class="msgPublicOptions">
                        <div class="msgReplyOptions">
                          <div class="ui big left icon input">
                            <input
                              autocomplete="off"
                              id="category"
                              v-on:keyup="showCategories"
                              placeholder="Tag category..."
                              type="text"
                            />
                            <i class="tag icon grey"></i>
                          </div>
                          <div class="selectedLabels">
                            <a
                              class="ui label"
                              v-for="cat in categoriesSelected"
                              :key="cat.catg_id"
                            >
                              {{ cat.catg_name }}
                              <i
                                class="delete icon"
                                @click="removeFromList(cat.catg_id)"
                              ></i>
                            </a>
                          </div>
                          <div
                            v-if="categoriesSearched.length > 0"
                            class="results"
                          >
                            <ul>
                              <div
                                class=""
                                @click="addToList(category)"
                                v-for="category in categoriesSearched"
                                :key="category.catg_id"
                              >
                                {{ category.catg_name }}
                              </div>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="msgPublicOptions" style="display: block;">
                        <div class="msgReplyOptions">
                          <div class="ui toggle checkbox">
                            <input
                              type="checkbox"
                              name=""
                              v-model="isglobal"
                              true-value="1"
                              false-value="0"
                            />
                            <label>GLOBAL RESPONSE</label>
                          </div>

                          <div class="msgMeta msgURL" v-if="isglobal == 0">
                            <b>ASKED FROM:</b>
                            <a target="_blank">
                              {{ message.domain_name }}
                              <i class="icon external alternate"></i>
                            </a>
                          </div>
                        </div>
                        <div class="msgReplyOptions">
                          <button
                            @click="openCalendar"
                            class="ui grey basic button large msgExpires c-datepicker-btn"
                            type="button"
                          >
                            <i class="ui calendar icon"></i>
                            ANSWER VALID THROUGH
                          </button>
                          <pre id="output"></pre>
                        </div>
                      </div>
                      <div class="msgReplyOptions">
                        <div class="msgSendContainer" style="display: block;">
                          <button
                            class="msgSend ui button large blue"
                            name="button"
                            type="button"
                            @click="
                              onSubmitAnswer(
                                key,
                                message.logid,
                                message.queue_id,
                                message
                              )
                            "
                          >
                            <span>
                              <i class="icon users"></i>
                              SEND &amp; INDEX RESPONSE
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div v-if="!message.privated">
                      <div class="msgReplyOptions">
                        <div class="msgSendContainer" style="display: block;">
                          <button
                            class="msgSend ui button large blue"
                            name="button"
                            type="button"
                            @click="
                              onSubmitAnswer(
                                key,
                                message.logid,
                                message.queue_id,
                                message
                              )
                            "
                          >
                            <span>
                              <i class="icon user"></i>
                              SEND RESPONSE
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import moment from "moment";
import Header from "../components/Header";

export default {
  name: "dashboard",
  components: {
    Header
  },
  data() {
    return {
      msg: "Hello World",
      messages: [],
      posts: [],
      arrayid: [],
      answer: [],
      isglobal: 0,
      expiration_date: "",
      suggestions: [],
      categories: [],
      categoriesSearched: [],
      categoriesSelected: []
    };
  },
  methods: {
    writeAnswer(key, suggestion) {
      this.answer[key] = suggestion;
      $(`#msgReply-${key}`).val(suggestion);
    },

    getSuggestions(message, key) {
      let data = {
        token: localStorage.getItem("token"),
        answer: this.answer[key],
        question: message.question
      };
      this.axios
        .post(this.$store.state.apiUrl + "/Read/suggestions.php", data)
        .then(res => {
          this.suggestions = res.data.data;
        })
        .catch(err => {
          console.error(err);
        });
    },
    openCalendar() {
      const picker = new MaterialDatePicker({}).on("submit", d => {
        this.expiration_date = d._d;
      });
      picker.open();
    },
    getDate: function(date) {
      return moment(date).format("dddd Do MMMM YYYY h:mm a");
    },
    onShowAskAnswer(id) {
      this.arrayid.push(id);
      this.$store.getters.getMessages.forEach(element => {
        if (element.queue_id == id) {
          element.opened = false;
        } else {
          element.opened = true;
        }
      });
    },
    hideSort(id) {
      this.categoriesSelected = [];
      this.categoriesSearched = [];
      let index = this.arrayid.indexOf(id);
      if (index > -1) {
        this.arrayid.splice(index, 1);
      }
    },
    onSubmitAnswer(key, question_id, queue_id, message) {
      let cats = [];
      let qtype = "public";
      if (!message.privated) {
        qtype = "private";
      }
      this.categoriesSelected.forEach(function(element){
        cats.push(element.catg_id);
      });
      let data = {
        token: localStorage.getItem("token"),
        answer: this.answer[key],
        question_id: question_id,
        queue_id: queue_id,
        qtype: qtype,
        isglobal: this.isglobal,
        expiration_date: this.expiration_date,
        catgs: cats
      };
      this.axios
        .post(this.$store.state.apiUrl + "/Update/replyQuestion.php", data)
        .then(res => {
          // unshift to push at the beginning of the array
          
          this.answer[key] = "";
          this.$store.dispatch("deleteMessage", message);
        })
        .catch(err => {
          console.error(err);
        });
    },
    async getCategories() {
      let response = await this.axios.post(
        this.$store.state.apiUrl + "Read/categories.php",
        {
          token: localStorage.getItem("token")
        }
      );
      this.categories = response.data.data;
    },
    showCategories() {
      let cats = [];
      let str = "uncategorized";
      this.categories.forEach(function(element) {
        if (
          element.catg_name.toLowerCase().indexOf(
            $("#category")
              .val()
              .toLowerCase()
          ) > -1 &&
          $("#category").val().length > 0
        ) {
          cats.push({catg_name: element.catg_name, catg_id : element.catg_id});
        }
        if (
          str.indexOf(
            $("#category")
              .val()
              .toLowerCase()
          ) > -1 &&
          $("#category").val().length > 0
        ) {
          cats.push({ catg_name: "Un-categorized", catg_id: 0 });
        }
      });
      this.categoriesSearched = cats;
    },
    addToList(category) {
      let tmpCategories = [];
      tmpCategories = this.categoriesSelected;
      if (
        tmpCategories.filter(element => element.catg_id === category.catg_id)
          .length < 1
      ) {
        tmpCategories.push(category);
        this.categoriesSelected = tmpCategories;
      }
      $("#category").val("");
      this.categoriesSearched = [];
    },
    removeFromList(category) {
      let tmpCategories = this.categoriesSelected.filter(
        element => element.catg_id !== category
      );
      this.categoriesSelected = tmpCategories;
    }
  },

  computed: {
    getFullMessages() {
      return this.$store.getters.getMessages;
    }
  },
  mounted() {
    $(".ui.dropdown").dropdown();
    this.getCategories();
  }
};
</script>

<style>
input#category {
  width: 277px;
}
.results ul {
  position: absolute;
  width: 277px;
  margin-top: 0px;
  padding: 0;
  z-index: 3;
}
.results ul div:last-child {
  border-bottom: 1px solid #e2e2e2;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}
.results ul div {
  padding: 10px;
  background: white;
  width: 100%;
  border: 1px solid #e2e2e2;
  transition: all 0.15s ease;
  border-bottom: none;
}
.results ul div:hover {
  background: #f7f7f7;
}
a.ui.label {
  cursor: pointer;
  margin: 2px !important;
}
.selectedLabels {
  width: calc(100% - 280px);
  display: inline-block;
  margin: auto;
  vertical-align: middle;
}
.content {
  display: flex;
  margin: 32px auto;
  padding: 0 16px;
  max-width: 960px;
  flex-direction: column;
  align-items: center;
}
.clearFix {
  clear: both;
}
.margin-20 {
  margin: 20px !important;
}
.msgText {
  background-color: white;
  padding: 15px;
}
.padding-l-40 {
  padding-left: 40px;
  padding-right: 20px;
}
.msgReplyOptions {
  width: 100%;
  padding: 15px 0px 15px;
}
.msgSort {
  float: right;
}
.msgSort label {
  font-size: 10pt;
  color: #666;
  padding: 5px 10px;
}
.msgSort select {
  border-radius: 3px;
  background: #f9f9f9;
  color: #666;
  padding: 5px 10px;
  cursor: pointer;
}
.msgSort option {
  font-size: 10pt;
  color: #666;
  background: #f9f9f9;
}
.msgContainer {
  margin: 0px 2% 2%;
  padding: 0px;
  width: 43%;
  float: left;
}
.width60 {
  width: 60%;
}
.msgMeta {
  font-size: 10pt;
  color: #a6a6a6;
  margin: 0px 0px 25px;
}
.checkbox label {
  margin: 0px 0px 20px;
}
.msgThumb {
  width: 100%;
  z-index: 100;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.msgThumb img {
  width: 100%;
  border-radius: 3px;
  margin: 0px 0px 5%;
  clip-path: polygon(
    0% 0%,
    100% 0%,
    100% 95%,
    60% 95%,
    50% 100%,
    40% 95%,
    0 95%
  );
}
.msgClose {
  float: left;
  margin: 0px 1% 0px;
  width: 3%;
  float: right;
}
.msgCloseMove {
  margin: -30px 1% 0px !important;
}
.msgText {
  font-size: 12pt;
  background: #fff;
  color: #6c6c6c;
  padding: 15px;
  line-height: 30px;
  border-radius: 3px;
  margin-top: -20px;
  z-index: auto;
  float: left;
  position: relative;
}
.msgText p {
  padding: 5px 32px;
}
.msgReplyOptions {
  width: 100%;
  padding: 15px 0px 15px;
}
.msgReplyOptions .button {
  min-width: 50%;
}
.msgScreenshot {
  width: 100%;
}
.msgScreenshot img {
  width: 100%;
  border-radius: 5px;
  -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
  filter: grayscale(100%);
}
.msgScreenshot img:hover {
  -webkit-filter: grayscale(0%); /* Safari 6.0 - 9.0 */
  filter: grayscale(0%);
}
.msgReply {
  font-size: 13pt !important;
  border-radius: 3px;
  padding: 0pt;
  margin: 0px;
  display: none;
}
.msgSuggestion {
  border-radius: 3px;
  background: #feffef;
  font-size: 12pt;
  color: #666;
  line-height: 25px;
  padding: 30px 20px 20px;
  margin: 10px 10px 0px;
  clip-path: polygon(
    15px 15px,
    100% 15px,
    100% 100%,
    0 100%,
    0 15px,
    50px 15px,
    32px 0
  );
}
.msgSuggestion:hover {
  border-left: 5px #f2711c solid;
  cursor: pointer;
  padding: 30px 20px 20px 15px;
  background: #fbffdb;
}

.msgSend {
  width: 100%;
}
.msgURL a {
  background: #fafafa;
  padding: 7px 10px;
  border-radius: 3px;
  cursor: pointer;
}

@media only screen and (max-width: 800px) {
  .msgContainer {
    width: 80% !important;
  }
}
@media only screen and (max-width: 600px) {
  .container {
    padding: 10px;
  }
  .msgContainer {
    width: 90% !important;
  }
}
.checkbox label {
  margin: 0px 0px 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue